import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/theme.css'
import { initSentry } from './sentry'
import App from './App.tsx'
import { ToastProvider } from './contexts/ToastContext'
import ErrorScreen from './components/ErrorScreen'
import { MISSING_API_URL } from './config'

initSentry()

const root = createRoot(document.getElementById('root')!)

if (MISSING_API_URL) {
  // Production build shipped without VITE_API_URL. Fail loud with an explanation
  // instead of silently falling back to localhost and hanging on every request.
  root.render(
    <StrictMode>
      <ErrorScreen
        title="Dashboard not configured"
        message="VITE_API_URL is not set for this build, so the dashboard has no backend to talk to. Set VITE_API_URL in the Vercel project's environment variables and redeploy."
        retryLabel="Reload"
        onRetry={() => window.location.reload()}
      />
    </StrictMode>,
  )
} else {
  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={({ resetError }) => (
        <ErrorScreen onRetry={resetError} />
      )}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </Sentry.ErrorBoundary>
    </StrictMode>,
  )
}
